import { createLocalHostApiFactory } from '../utils/local-host';

/**
 * Tells POS that continue button has been clicked.
 */
const continueClicked: () => Promise<void> = createLocalHostApiFactory(() => {},
500);

const view = {
  continueClicked,
};

export { view };
